import * as React from 'react';

export const AboutUsPage = () => {
  return <div />;
};
